var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjDivider", [
        _vm._v(
          _vm._s(_vm.$t("BusinessPurchaseOrder2.code")) +
            "：" +
            _vm._s(_vm.queryParams.code)
        ),
      ]),
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "bj-query-form bj-query-form-for-cal-height",
          attrs: {
            size: "mini",
            model: _vm.queryParams.purchaseOrderReceive,
            rules: _vm.rules,
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("BusinessPurchaseOrder2.Unit"),
                        prop: "shippingMethod",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: {
                          "option-list": _vm.PO_SHIPPINGMETHOD_STATUS_LIST,
                          placeholder: _vm.$t("BusinessPurchaseOrder2.Unit"),
                        },
                        on: { change: _vm.onChangeSM },
                        model: {
                          value:
                            _vm.queryParams.purchaseOrderReceive.shippingMethod,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.queryParams.purchaseOrderReceive,
                              "shippingMethod",
                              $$v
                            )
                          },
                          expression:
                            "queryParams.purchaseOrderReceive.shippingMethod",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.queryParams.purchaseOrderReceive.shippingMethod ===
              "Container"
                ? _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "BusinessPurchaseOrder2.form.containerId"
                            ),
                            prop: "containerID",
                          },
                        },
                        [
                          _c("BjInputNumber", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.containerID,
                              callback: function ($$v) {
                                _vm.containerID = $$v
                              },
                              expression: "containerID",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.queryParams.purchaseOrderReceive.shippingMethod ===
              "Container"
                ? _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("BusinessPurchaseOrder2.form.isTrue"),
                            prop: "isTrue",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              disabled: _vm.isShowNewCont,
                              "option-list": _vm.STATUS_YES_TRUE,
                            },
                            model: {
                              value: _vm.isTrue,
                              callback: function ($$v) {
                                _vm.isTrue = $$v
                              },
                              expression: "isTrue",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.queryParams.purchaseOrderReceive.shippingMethod ===
                "Container" && !_vm.isTrue
                ? _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "BusinessPurchaseOrder2.form.newContainerId"
                            ),
                            prop: "newContainerID",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              type: "text",
                              maxlength: _vm.MAX_LENGTH.DEFAULT,
                              placeholder: _vm.$t(
                                "BusinessPurchaseOrder2.form.newContainerId"
                              ),
                            },
                            model: {
                              value: _vm.newContainerID,
                              callback: function ($$v) {
                                _vm.newContainerID = $$v
                              },
                              expression: "newContainerID",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.queryParams.purchaseOrderReceive.shippingMethod ===
              "Container"
                ? _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("BusinessPurchaseOrder3.Type"),
                            prop: "containerType",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              "option-list": _vm.PO_CONTAINERTYPE_STATUS_LIST,
                              placeholder: _vm.$t(
                                "BusinessPurchaseOrder3.Type"
                              ),
                            },
                            on: { change: _vm.onChangeCT },
                            model: {
                              value:
                                _vm.queryParams.purchaseOrderReceive
                                  .containerType,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryParams.purchaseOrderReceive,
                                  "containerType",
                                  $$v
                                )
                              },
                              expression:
                                "queryParams.purchaseOrderReceive.containerType",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.queryParams.purchaseOrderReceive.shippingMethod ===
              "Container"
                ? _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("BusinessPurchaseOrder3.Size"),
                            prop: "containerLength",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              "option-list": _vm.PO_CONTAINERLENGTH_STATUS_LIST,
                              placeholder: _vm.$t(
                                "BusinessPurchaseOrder3.Size"
                              ),
                            },
                            on: { change: _vm.onChangeCL },
                            model: {
                              value:
                                _vm.queryParams.purchaseOrderReceive
                                  .containerLength,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryParams.purchaseOrderReceive,
                                  "containerLength",
                                  $$v
                                )
                              },
                              expression:
                                "queryParams.purchaseOrderReceive.containerLength",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.queryParams.purchaseOrderReceive.shippingMethod ===
                "Container" &&
              _vm.queryParams.purchaseOrderReceive.containerType != "Pallet"
                ? _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("BusinessPurchaseOrder3.Total"),
                            prop: "totalPalletQty",
                          },
                        },
                        [
                          _c("BjInputNumber", {
                            attrs: {
                              placeholder: _vm.$t(
                                "BusinessPurchaseOrder3.Total"
                              ),
                            },
                            model: {
                              value:
                                _vm.queryParams.purchaseOrderReceive
                                  .totalPalletQty,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryParams.purchaseOrderReceive,
                                  "totalPalletQty",
                                  $$v
                                )
                              },
                              expression:
                                "queryParams.purchaseOrderReceive.totalPalletQty",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.queryParams.purchaseOrderReceive.shippingMethod === "Carton"
                ? _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("BusinessPurchaseOrder3.cartonQty"),
                            prop: "cartonQty",
                          },
                        },
                        [
                          _c("BjInputNumber", {
                            attrs: {
                              placeholder: _vm.$t(
                                "BusinessPurchaseOrder3.cartonQty"
                              ),
                            },
                            model: {
                              value:
                                _vm.queryParams.purchaseOrderReceive.cartonQty,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryParams.purchaseOrderReceive,
                                  "cartonQty",
                                  $$v
                                )
                              },
                              expression:
                                "queryParams.purchaseOrderReceive.cartonQty",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.queryParams.purchaseOrderReceive.shippingMethod === "Carton"
                ? _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("BusinessPurchaseOrder3.Hire"),
                            prop: "csgPallet",
                          },
                        },
                        [
                          _c("BjInputNumber", {
                            attrs: {
                              placeholder: _vm.$t(
                                "BusinessPurchaseOrder3.Hire"
                              ),
                            },
                            model: {
                              value:
                                _vm.queryParams.purchaseOrderReceive.csgPallet,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryParams.purchaseOrderReceive,
                                  "csgPallet",
                                  $$v
                                )
                              },
                              expression:
                                "queryParams.purchaseOrderReceive.csgPallet",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("BusinessPurchaseOrder3.Extra"),
                        prop: "labourTime",
                      },
                    },
                    [
                      _c(
                        "BjInputNumber",
                        {
                          attrs: {
                            placeholder: _vm.$t("BusinessPurchaseOrder3.Extra"),
                          },
                          model: {
                            value:
                              _vm.queryParams.purchaseOrderReceive.labourTime,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryParams.purchaseOrderReceive,
                                "labourTime",
                                $$v
                              )
                            },
                            expression:
                              "queryParams.purchaseOrderReceive.labourTime",
                          },
                        },
                        [
                          _c(
                            "template",
                            { slot: "append" },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    content: _vm.$t(
                                      "BusinessPurchaseOrder3.Ps1"
                                    ),
                                    placement: "bottom",
                                  },
                                },
                                [_c("i", { staticClass: "el-icon-question" })]
                              ),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 * 2 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("BusinessPurchaseOrder3.comments"),
                        prop: "comments",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          type: "textarea",
                          "show-word-limit": "",
                          autosize: "",
                          maxlength: 999,
                          placeholder: _vm.$t(
                            "BusinessPurchaseOrder3.comments"
                          ),
                          clearable: "",
                        },
                        model: {
                          value: _vm.queryParams.purchaseOrderReceive.comments,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.queryParams.purchaseOrderReceive,
                              "comments",
                              $$v
                            )
                          },
                          expression:
                            "queryParams.purchaseOrderReceive.comments",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.queryParams.purchaseOrderReceive.shippingMethod === "Pallets" ||
          _vm.queryParams.purchaseOrderReceive.containerType == "Pallet"
            ? _c("palletTable", {
                ref: "palletTableRef",
                attrs: { tableData: [_vm.queryParams.purchaseOrderReceive] },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-row",
        { staticStyle: { margin: "20px 0" } },
        [
          _c(
            "el-col",
            [
              _vm.queryParams.purchaseOrderReceive.shippingMethod != "Container"
                ? _c(
                    "el-button",
                    {
                      staticClass: "main-btn",
                      attrs: { type: "primary" },
                      on: { click: _vm.onPARTIAL },
                    },
                    [_vm._v(_vm._s(_vm.$t("BusinessPurchaseOrder3.PARTIAL")))]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  staticClass: "main-btn",
                  attrs: { type: "primary" },
                  on: { click: _vm.onFULLY },
                },
                [_vm._v(_vm._s(_vm.$t("BusinessPurchaseOrder3.FULLY")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.tableList,
            border: "",
            script: "",
            "max-height": "600px",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "shippingMethod",
              label: _vm.$t("BusinessPurchaseOrder2.Unit"),
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "creationDate",
              label: _vm.$t("BusinessPurchaseOrder3.Submit"),
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "containerLength",
              label: _vm.$t("BusinessPurchaseOrder3.Size"),
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "containerType",
              label: _vm.$t("BusinessPurchaseOrder3.Type"),
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "totalPalletQty",
              label: _vm.$t("BusinessPurchaseOrder3.Total"),
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "csgPallet",
              label: _vm.$t("BusinessPurchaseOrder3.Hire"),
              align: "center",
            },
          }),
          _c(
            "el-table-column",
            {
              attrs: {
                label: _vm.$t("BusinessPurchaseOrder3.CustomerPalletQty"),
                align: "center",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "standardPallet",
                  label: _vm.$t("BusinessPurchaseOrder3.Standard"),
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "chepPallet",
                  label: _vm.$t("BusinessPurchaseOrder3.Chep"),
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "loscomPallet",
                  label: _vm.$t("BusinessPurchaseOrder3.Loscom"),
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "nonStandardPallet",
                  label: _vm.$t("BusinessPurchaseOrder3.nonStandard"),
                  align: "center",
                },
              }),
            ],
            1
          ),
          _c("el-table-column", {
            attrs: {
              prop: "cartonQty",
              label: _vm.$t("BusinessPurchaseOrder3.cartonQty"),
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "labourTime",
              label: _vm.$t("BusinessPurchaseOrder3.Extra"),
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "comments",
              label: _vm.$t("BusinessPurchaseOrder3.comments"),
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "createdName",
              label: _vm.$t("BusinessPurchaseOrder3.Submitter"),
              align: "center",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }